import { Box, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { ReactElement, useMemo } from 'react';
import { EuroOutlined, LocalShippingOutlined, ScheduleOutlined, ThumbUpOutlined } from '@mui/icons-material';
import { OrdersCategories, orderListUiStateAtom } from '../state/state';
import OrderCategoryChip from './OrderCategoryChip';
import { OrdersCountByCategoryMap } from './OrderList';

type OrderCategoriesSelectionProps = {
  ordersCountByCategory: OrdersCountByCategoryMap;
  handleCategoryChange: (selectedCategory: OrdersCategories) => void;
}

type OrderCategoriesWordingsAndIconsMap = {
  [status in OrdersCategories]: { label: string, icon?: ReactElement };
}

const ORDERS_CATEGORIES_WORDINGS_AND_ICONS: OrderCategoriesWordingsAndIconsMap = {
  IN_PROGRESS: {
    label: 'order:orders_in_progress',
  },
  VALIDATION: {
    label: 'order:validation',
    icon: <ScheduleOutlined />,
  },
  DELIVERY: {
    label: 'common:delivery',
    icon: <LocalShippingOutlined />,
  },
  PAYMENT: {
    label: 'order:payment',
    icon: <EuroOutlined />,
  },
  COMPLETED: {
    label: 'order:completed',
    icon: <ThumbUpOutlined />,
  },
  ALL: {
    label: 'order:all_orders',
  },
};

const orderedCategories = [
  OrdersCategories.IN_PROGRESS,
  OrdersCategories.ALL,
  OrdersCategories.VALIDATION,
  OrdersCategories.DELIVERY,
  OrdersCategories.PAYMENT,
  OrdersCategories.COMPLETED,
];

export default function OrderCategoriesSelection({ ordersCountByCategory, handleCategoryChange }: OrderCategoriesSelectionProps): React.JSX.Element {
  const { t } = useTranslation(['common', 'order']);
  const { currentSetCategory } = useAtomValue(orderListUiStateAtom);

  const categoriesChips = useMemo(() => (

    orderedCategories.map((category) => (
      <>
        <OrderCategoryChip
          key={category}
          label={`${t(ORDERS_CATEGORIES_WORDINGS_AND_ICONS[category].label, { count: ordersCountByCategory[category] })} (${ordersCountByCategory[category]})`}
          icon={ORDERS_CATEGORIES_WORDINGS_AND_ICONS[category].icon}
          category={category}
          selectedCategory={currentSetCategory}
          onClick={handleCategoryChange}
        />

        {(category === OrdersCategories.IN_PROGRESS || category === OrdersCategories.ALL) && (
          <Divider
            flexItem
            orientation="vertical"
            sx={{
              my: 0.5,
            }}
          />
        )}
      </>
    ))
  ), [currentSetCategory, handleCategoryChange, ordersCountByCategory]);

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        overflowX: 'auto',
      }}
    >
      {categoriesChips}
    </Box>
  );
}
